import { render, staticRenderFns } from "./productLabel.vue?vue&type=template&id=4d82bc5d&scoped=true&"
import script from "./productLabel.vue?vue&type=script&lang=js&"
export * from "./productLabel.vue?vue&type=script&lang=js&"
import style0 from "./productLabel.vue?vue&type=style&index=0&id=4d82bc5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82bc5d",
  null
  
)

export default component.exports